import React, { FC } from 'react';
import { Theme, Box, makeStyles, Container } from '@material-ui/core';
import ReactTypingEffect from 'react-typing-effect';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    marginTop: theme.spacing(20),
    padding: theme.spacing(8, 0),
    backgroundColor: theme.palette.primary.dark,
  },
  text: {
    fontWeight: 300,
    color: theme.palette.common.white,
    fontSize: 20,
    '@media(min-width: 600px)': {
      fontSize: 23,
    },
  },
}));

const StringSection: FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.background}>
      <Container fixed>
        <ReactTypingEffect
          speed={50}
          eraseSpeed={10}
          text={"We leverage consistency, commitment, and dedication. We don't wait for success. We work for it!"}
          className={classes.text}
        />
      </Container>
    </Box>
  );
};

export default StringSection;
